import moment, { Moment } from "moment";
import "moment-timezone";

export const DATE_TIME_FORMAT = "DD.MM.YYYY HH:mm:ss";
export const DATE_FORMAT = "DD.MM.YYYY";

export const formatDate = (date, format = DATE_TIME_FORMAT) => {
  if (!date || date.length === 0) return date;
  const momentDate = moment(date);
  if (momentDate.isValid()) {
    return momentDate.format(format);
  }
  return momentDate;
};

export const formatUtcDate = (date, format = DATE_TIME_FORMAT) => {
  if (!date || date.length === 0) return date;
  const momentDate = moment(date).utc();
  if (momentDate.isValid()) {
    return momentDate.format(format);
  }
  return momentDate;
};


export const compareDatesForTable = (dateA: Moment, dateB: Moment): number => {
  return moment(dateA).isAfter(moment(dateB)) ? 1 : -1;
};

const DEFAULT_TIMEZONE = "Europe/Zurich";

export const formatDateTZ = (
  date: string | null | undefined,
  format = "DD.MM.YYYY HH:mm",
  tz: string = DEFAULT_TIMEZONE,
  fallback = "—",
): string => {
  if (!date) return fallback;
  return moment.tz(date, tz).format(format);
};

export const parseZurichDate = (
  date: string | undefined,
  fallback = new Date(),
): Date => {
  if (!date) return fallback;
  return moment.tz(date, DEFAULT_TIMEZONE).toDate();
};

export const buildDatetimeInTZ = (
  date: Date,
  time: string,
  tz = DEFAULT_TIMEZONE,
): string =>
  moment.tz(`${moment(date).format("YYYY-MM-DD")}T${time}`, tz).format();
